// extracted by mini-css-extract-plugin
export var aircallIframe = "_ef-3";
export var fabContainer = "_ef-5";
export var fabRinging = "_ef-6";
export var loadingOverlay = "_ef-4";
export var pulse = "_ef-7";
export var widgetContent = "_ef-2";
export var widgetPanel = "_ef-0";
export var widgetPanelExpanded = "_ef-1";